import { ENV } from '../../config/runtimeEnv';
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_LABIQ_SERVER;

// Get all lab orders
export async function getLabOrders(status: string | null = null) {
	const res = await http.get(`${API_BASE_URL}/orders`, {
		params: status !== null ? { status } : {},
	});
	return res.data;
}

// Get a single lab order by order id
export async function getLabOrder(orderId: number) {
	const res = await http.get(`${API_BASE_URL}/orders/${orderId}`);
	return res.data;
}

// Create a new lab order
export async function createLabOrder(orderData: any) {
	const res = await http.post(`${API_BASE_URL}/orders`, orderData);
	return res.data;
}

// Update an existing lab order
export async function updateLabOrder(orderId: number, orderData: any) {
	const res = await http.put(`${API_BASE_URL}/orders/${orderId}`, orderData);
	return res.data;
}

export async function sendResultsForLabOrder(orderId: number, analysisId?: number) {
	const res = await http.post(`${API_BASE_URL}/orders/${orderId}/results`,{
		analysis_id: analysisId
	});
	return res.data;
}

// Delete a lab order
export async function deleteLabOrder(orderId: number) {
	const res = await http.delete(`${API_BASE_URL}/orders/${orderId}`);
	return res.data;
}

export async function updateLabOrderStatus(orderId: number, status: string, items?: { id: number; status: string }[]) {
	const res = await http.post(
		`${API_BASE_URL}/orders/${orderId}/status`,
		{ status, order_items: items }
	);
	return res.data;
}

// NEW: Update shipping status
export async function updateOrderShippingStatus(orderId: number,
	shippingData: {
		shipping_status: string;
		tracking_number?: string;
		delivery_vendor?: string;
		shipped_at?: string;
		delivered_at?: string;
		shipping_notes?: string;
	}
) {
	const res = await http.put(
		`${API_BASE_URL}/orders/${orderId}/shipping`,
		shippingData
	);
	return res.data;
}

// NEW: Get tracking information
export async function getOrderTrackingInfo(orderId: number) {
	const res = await http.get(`${API_BASE_URL}/orders/${orderId}/tracking`);
	return res.data;
}